// R56: backend, catalogue, source feed and schedules verified 2026-09-29.
// The authenticated server capability is still required for each entrance.
const OPNOPOLY_UI_RELEASE_READY = true;
function entryReady(view,uiReady=OPNOPOLY_UI_RELEASE_READY){return uiReady===true&&!!view&&view.available===true&&view.entryVisible===true;}
export {OPNOPOLY_UI_RELEASE_READY,entryReady};
